import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import QRCode from 'qrcode';
import AsyncLocalStorage from "../../util/AsyncLocalStorage";
import UserController from "../../controller/UserController";

let LoginQrCheckTimeout: any;
const TestCarUuid = "123가1234";

const QRCodeScreen = ({ setStep }: any) => {
  const [qrCodeImgUrl, set_qrCodeImgUrl] = useState<string>(`${process.env.PUBLIC_URL}/img/loginQR.png`);


  const generateQrCode = async () => {
    let sUrl = "https://api-stg.throo.kr/obigo/login/qr/" + TestCarUuid;
    const BufferQRCode: any = await QRCode.toDataURL(sUrl, { width: 162 });
    set_qrCodeImgUrl(BufferQRCode);
  }

  const checkLoggedInWithQr = async () => {
    clearTimeout(LoginQrCheckTimeout);
    LoginQrCheckTimeout = setTimeout(async () => {
      let oRes = await UserController.checkLoggedInWithQr({ car_uuid: TestCarUuid });
      let oResData = oRes.data;
      if (oRes && oRes.status && oResData && oResData.success) {
        //console.log('oRes', oRes);
        if (oResData.user && oResData.user.user_list_cnt > 1) {
          clearTimeout(LoginQrCheckTimeout);
          setStep(2);
        } else {
          checkLoggedInWithQr();
        }

      } else {
        checkLoggedInWithQr();
      }
    }, 3000);
  }

  useEffect(() => {
    clearTimeout(LoginQrCheckTimeout);
    generateQrCode();

    return () => {
      clearTimeout(LoginQrCheckTimeout);
    };
  }, []);

  useEffect(() => {
    checkLoggedInWithQr();
  }, [qrCodeImgUrl]);

  const goNextStep = () => {
    setStep(2);
  };

  return (
    <div className="wrapper">
      <img
        src={`${process.env.PUBLIC_URL}/svg/throoLogo.svg`}
        alt="스루로고"
        className="logo"
      />
      <div>
        <img
          src={`${qrCodeImgUrl}`}
          onClick={goNextStep}
          alt="로그인 qr코드"
          style={{
            maxWidth: "162px",
          }}
        />
        <h2>
          사용자를 추가합니다. <br />
          QR화면에서 등록 가능합니다.
        </h2>
      </div>
    </div>
  );
};
export default QRCodeScreen;
